var React = require('react');

function Pdf (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M127.6,29L127.6,29L99,0.4V0h-0.4l-0.1-0.1L98.4,0H10C4.5,0,0,4.5,0,10v150c0,5.5,4.5,10,10,10h108c5.5,0,10-4.5,10-10V29\n\tH127.6z M35.5,134.9c2.1,2.6,4.9,4,8.2,4c3.4,0,6-1.1,7.7-3.4c1-1.2,1.8-3,2.4-5.5h9.8c-0.8,5.1-3,9.3-6.5,12.6\n\tc-3.5,3.2-7.9,4.8-13.4,4.8c-6.7,0-12-2.2-15.9-6.5c-3.8-4.4-5.8-10.4-5.8-18c0-8.2,2.2-14.6,6.6-19.1c3.8-3.9,8.6-5.8,14.5-5.8\n\tc7.9,0,13.6,2.6,17.2,7.8c2,2.9,3.1,5.9,3.2,8.8h-9.9c-0.6-2.3-1.4-4-2.4-5.1c-1.8-2.1-4.4-3.1-7.8-3.1c-3.5,0-6.3,1.4-8.3,4.3\n\ts-3,7-3,12.3C32.3,128.3,33.4,132.2,35.5,134.9z M93.5,146h-9.3l-16-47.2h10.5L89,134.7l10.4-35.9h10.3L93.5,146z M109,29\n\tc-5.5,0-10-4.5-10-10V4.6L123.4,29H109z"}));
}

Pdf.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 128 170","style":{"enableBackground":"new 0 0 128 170"},"xmlSpace":"preserve","fill":"currentColor","stroke":"currentColor"};

module.exports = Pdf;

Pdf.default = Pdf;
